import { render, staticRenderFns } from "./EventInfoDates.vue?vue&type=template&id=54ca9210&"
import script from "./EventInfoDates.vue?vue&type=script&lang=ts&"
export * from "./EventInfoDates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports